import { UPDATE_LESSON_SEARCH_FILTER } from '../../actions/admin/adminLessonActions'

const initialRequestState = {
  term: '',
  grades: '',
  owned: false,
  shared: false
}
const reducers = (state = initialRequestState, action) => {
  switch (action.type) {
    case UPDATE_LESSON_SEARCH_FILTER:
      const newState = {
        ...state,
        [action.key]: action.value
      }

      console.log(newState)

      return newState
    default:
      return state
  }
}

export default reducers
